.session-context-boundary {
  position: fixed;
  inset: 0;
  width: 100vw;
  height: 100dvh;
  max-width: none;
  max-height: none;
  margin: 0;
  border: 0;
  box-sizing: border-box;
  display: grid;
  place-items: center;
  padding: 1rem;
  background: transparent;
}

.session-context-boundary::backdrop { background: rgb(15 23 42 / 72%); }

.session-context-boundary__card {
  width: min(100%, 36rem);
  max-height: calc(100dvh - 2rem);
  overflow: auto;
  padding: 1.5rem;
  border-radius: 1rem;
  background: #fff;
  color: #172033;
  box-shadow: 0 1rem 4rem rgb(0 0 0 / 20%);
  line-height: 1.7;
}

.session-context-boundary__card h1 { font-size: 1.3rem; margin-block: 0 1rem; }
.session-context-boundary__card button {
  min-height: 2.75rem;
  width: 100%;
  padding: .65rem 1rem;
  border: 0;
  border-radius: .65rem;
  background: #172033;
  color: #fff;
  cursor: pointer;
  font: inherit;
}
.session-context-boundary__card button:focus-visible { outline: 3px solid #2581eb; outline-offset: 3px; }
